import { Avatar, Button, Divider, Stack, Typography } from '@mui/material';
import { ButtonsBackground } from 'Components/ButtonsBackground';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Download2, LeftArrow } from 'Images';
import { useNavigate } from 'react-router-dom';

interface IButtonLinkOrDownloadProps {
  isDownload?: boolean;
  downloadFile?: () => void;
  isCallbackNavigation?: boolean;
  callbackNavigation?: () => void;
  label: string;
  url: string;
  isMobileVersion?: boolean;
  isWidthBtn?: boolean;
}

export const MAX_CHARS_BTN_LIMIT = 15;

export const ButtonLinkOrDownload = ({
  label,
  url,
  isDownload,
  downloadFile,
  isCallbackNavigation,
  callbackNavigation,
  isMobileVersion,
  isWidthBtn,
}: IButtonLinkOrDownloadProps) => {
  const navigate = useNavigate();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userUpdates;
  const isDesktop = useIsDesktop();

  return isMobileVersion ? (
    <Stack
      flexDirection={'row'}
      gap={isDesktop ? '8px' : '6px'}
      height={isDesktop ? '56px' : '42px'}
      justifyContent={isDownload ? 'space-around' : 'end'}
      alignItems={'center'}
      p={isDesktop ? '18px 32px' : '18px 20px'}
      position={'relative'}
      overflow={'hidden'}
      mt={isDesktop ? '32px' : '24px'}
    >
      <ButtonsBackground />
      {isDownload && (
        <>
          <Button
            sx={{ gap: isDesktop ? '8px' : '6px', p: 0 }}
            onClick={downloadFile}
            aria-label={dictionary.downloadFile}
          >
            <Avatar
              sx={{
                width: isDesktop ? '24px' : '20px',
                height: isDesktop ? '24px' : '20px',
              }}
              src={Download2}
              alt=''
            />
            <Typography variant='body5'>{dictionary.download}</Typography>
          </Button>
          <Divider
            sx={{
              borderColor: 'primary.shade_200',
              zIndex: 2,
              height: isDesktop ? undefined : '20px',
              mt: isDesktop ? undefined : '-6px',
            }}
            flexItem
            orientation='vertical'
          />
        </>
      )}

      <Button
        sx={{ gap: isDesktop ? '8px' : '6px', p: 0 }}
        onClick={
          isCallbackNavigation ? callbackNavigation : () => navigate(url)
        }
      >
        <Typography variant='body5'>{label}</Typography>
        <Avatar
          sx={{
            width: isDesktop ? '24px' : '20px',
            height: isDesktop ? '24px' : '20px',
          }}
          src={LeftArrow}
          alt=''
        />
      </Button>
    </Stack>
  ) : (
    <Stack
      flexDirection={'row'}
      sx={{
        cursor: 'pointer',
        backgroundColor: 'primary.shade_100',
        boxShadow: '0px 2px 8px 0px rgba(4, 16, 46, 0.04)',
        border: '1px solid rgba(183, 204, 255, 0.20)',
        borderRadius: '100px',
        p: isDesktop ? '5px 16px' : '4px 15px',
        width:
          isDownload && isDesktop
            ? '265px'
            : isDownload
            ? '100%'
            : isWidthBtn
            ? 'max-content'
            : '159px',
        justifyContent: isDownload ? 'space-between' : 'center',
        alignItems: 'center',
        marginLeft: 'auto',
      }}
    >
      {isDownload && (
        <>
          <Button onClick={downloadFile} aria-label={dictionary.downloadFile}>
            <Avatar
              src={Download2}
              alt=''
              sx={{ width: '20px', height: '20px', mr: 1 }}
            />
            <Typography variant='body5'>{dictionary.download}</Typography>
          </Button>

          <Divider
            aria-hidden='true'
            orientation='vertical'
            flexItem
            variant='middle'
            sx={{ borderColor: 'primary.shade_200' }}
          />
        </>
      )}
      <Button
        onClick={
          isCallbackNavigation ? callbackNavigation : () => navigate(url)
        }
        sx={{ display: 'flex', p: '6px 0' }}
        aria-label={`${dictionary.navigateTo} ${label}`}
      >
        <Typography variant='body5'>{label}</Typography>
        <Avatar src={LeftArrow} alt='' sx={{ width: '20px', height: '20px' }} />
      </Button>
    </Stack>
  );
};
